var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprintSidebarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sprints",
    d: "M443.81,406.92h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-9A3,3,0,0,0,443.81,406.92Zm-9.741,7.059a.5.5,0,0,1,.7-.06,4.536,4.536,0,1,1,8.822,1.59.5.5,0,0,1-.473.338.484.484,0,0,1-.162-.028.5.5,0,0,1-.311-.634,3.607,3.607,0,0,0,.2-1.172,3.534,3.534,0,0,0-7.066-.146.5.5,0,0,1,.665.057.5.5,0,0,1-.031.707l-.8.734a.5.5,0,0,1-.661.013l-.818-.693A.5.5,0,0,1,434.069,413.979Zm8.826,2.83a4.517,4.517,0,0,1-.41.464.5.5,0,0,1-.7-.709,3.486,3.486,0,0,0,.322-.365.5.5,0,1,1,.793.61Zm-2.338-1.7a.5.5,0,0,1-.711.7l-1.02-1.029a.5.5,0,0,1-.144-.351v-2.259a.5.5,0,1,1,1,0v2.053Zm4.947,3.044a.484.484,0,0,1-.02.1.474.474,0,0,1-.07.124.16.16,0,0,1-.013.022l-.012.016c-.01.01-.017.022-.027.032l-.649.778a.5.5,0,0,1-.769-.638h-9.373a.5.5,0,0,1,0-1h1.912a4.549,4.549,0,0,1-.644-.614.5.5,0,0,1,.765-.645,3.52,3.52,0,0,0,2.689,1.259h4.614a.5.5,0,0,1,.754-.651l.729.809a.5.5,0,0,1,.126.334l0,.008A.5.5,0,0,1,445.5,418.153Z",
    transform: "translate(-431.81 -406.92)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprintSidebarImage);
export default __webpack_public_path__ + "static/media/Sprint-sidebar-image.0e4e38115448f3924047fd0acc46c1be.svg";
export { ForwardRef as ReactComponent };